import _ from 'lodash';
import { createSelector } from 'reselect';
import { getVideoIds } from '../../../../redux/lazy-channel-videos/selectors';

export const isSingleVideoView = createSelector(
  [getVideoIds],
  (videoIds) => _.size(videoIds) === 1,
);
